const translations = {
  "en": {
    "Upgrade Plan": "Upgrade Plan",
    "Your imported portfolio data is not up-to-date. Last Update time: {time}": "Your imported portfolio data is not up-to-date. Last Update time: {time}"
  },
  "zh-tw": {
    "Upgrade Plan": "升級方案",
    "Your imported portfolio data is not up-to-date. Last Update time: {time}": "你匯入的投資組合資料未及時更新。最後更新時間：{time}"
  }
};

export default translations;
